import { Instagram, Facebook, Linkedin, ArrowUp } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
  const content = useContent();
  const f = content.footer;
  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t border-gold/15 bg-obsidian">
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-20 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-end">
          <div>
            <p className="font-display text-[16vw] font-extrabold leading-none tracking-tight text-outline-faint select-none sm:text-[9rem] lg:text-[11rem]">
              REYA
            </p>
            <p className="-mt-4 font-mono text-xs uppercase tracking-[0.35em] text-gold sm:-mt-8">
              {f.tagline}
            </p>
          </div>
          <div className="flex flex-col gap-6">
            <nav className="flex flex-wrap gap-6">
              {[
                { label: "Hizmetler", href: "#hizmetler", testid: "footer-link-services" },
                { label: "Manifesto", href: "#manifesto", testid: "footer-link-manifesto" },
                { label: "İşler", href: "#isler", testid: "footer-link-work" },
                { label: "İletişim", href: "#iletisim", testid: "footer-link-contact" },
              ].map((l) => (
                <button
                  key={l.href}
                  data-testid={l.testid}
                  onClick={() => scrollToId(l.href)}
                  className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-gold"
                >
                  {l.label}
                </button>
              ))}
            </nav>
            <div className="flex items-center gap-3">
              {[
                { icon: Instagram, testid: "footer-social-instagram", label: "Instagram" },
                { icon: Facebook, testid: "footer-social-facebook", label: "Facebook" },
                { icon: Linkedin, testid: "footer-social-linkedin", label: "LinkedIn" },
              ].map((s) => (
                <a
                  key={s.testid}
                  data-testid={s.testid}
                  href="#iletisim"
                  onClick={(e) => { e.preventDefault(); scrollToId("#iletisim"); }}
                  aria-label={s.label}
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/20 text-zinc-400 transition-all duration-300 hover:border-gold hover:text-gold"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
              <button
                data-testid="footer-back-to-top"
                onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
                aria-label="Yukarı çık"
                className="ml-3 flex h-11 w-11 items-center justify-center rounded-full bg-gold text-obsidian transition-transform duration-300 hover:scale-110"
              >
                <ArrowUp className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-3 border-t border-gold/10 pt-6 sm:flex-row sm:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">
            {f.copyright}
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">
            {f.meta}
          </p>
        </div>
      </div>
    </footer>
  );
}
